import React from 'react';
import { Grid, Button } from 'semantic-ui-react';
import { Field } from 'redux-form';

import { InputMode } from 'Common/FormEnum';
import {
  InputField,
  DatePickerField,
  SelectField,
} from 'Common/SemanticWrapper';
import { SiteComponent } from 'Common/SiteComponent';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';

export const StudentInformationForm = ({
  isNewStudent,
  gradeOptions,
  raceOptions,
  ethnicityOptions,
  changeServingNumber,
  changeStudentNumber,
}) => {
  return (
    <Grid>
      <Grid.Row columns={'equal'}>
        <Grid.Column>
          <Field
            component={InputField}
            label={'First Name'}
            maxLength={20}
            name={Fields.FirstName}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Middle Name'}
            maxLength={20}
            name={Fields.MiddleName}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Last Name'}
            maxLength={20}
            name={Fields.LastName}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={'equal'}>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Student #'}
            maxLength={12}
            name={Fields.Id}
            mode={InputMode.Integer}
            disabled={!isNewStudent}
            onChange={changeStudentNumber}
            hideSpinner={false}
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={InputField}
            label={'Serving #'}
            maxLength={12}
            name={Fields.ServingNumber}
            mode={InputMode.Integer}
            disabled={!isNewStudent}
            action={
              isNewStudent ? (
                <Button
                  type="button"
                  icon="refresh"
                  onClick={changeServingNumber}
                />
              ) : null
            }
          />
        </Grid.Column>
        <Grid.Column>
          <Field
            component={DatePickerField}
            label={'DOB'}
            name={Fields.BirthDate}
            dateFormat="MM/DD/YYYY"
            zIndex={1000}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={7}>
          <SiteComponent
            name={Fields.SiteId}
            isForm={true}
            isAllRequired={false}
            style={{ zIndex: 102 }}
            fetchAllSites={true}
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <Field
            name={Fields.Teacher}
            component={InputField}
            label={'Teacher'}
            maxLength={20}
          />
        </Grid.Column>
        <Grid.Column width={5}>
          <Field
            name={Fields.GradeId}
            component={SelectField}
            label={'Grade'}
            options={gradeOptions}
            style={{ zIndex: 101 }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <Field
            name={Fields.RaceId}
            component={SelectField}
            label={'Race'}
            options={raceOptions}
            style={{ zIndex: 100 }}
          />
        </Grid.Column>
        <Grid.Column width={5}>
          <Field
            name={Fields.EthnicityId}
            component={SelectField}
            label={'Ethnicity'}
            options={ethnicityOptions}
            style={{ zIndex: 100 }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/student/StudentInformationForm.js